/* Bailey & Beau — lightweight carousel (no dependencies).
   Markup contract:
     <div class="bb-carousel" data-bb-carousel>
       <div class="bb-carousel-track">  (horizontal scroll-snap track)
         ...slides...
       </div>
       <button data-bb-prev>…</button>
       <button data-bb-next>…</button>
     </div>
   Falls back to a plain scrollable row if JS is off. */
(function () {
  function initCarousel(root) {
    if (root.dataset.bbInit) return;
    root.dataset.bbInit = '1';
    var track = root.querySelector('.bb-carousel-track');
    if (!track) return;
    var prev = root.querySelector('[data-bb-prev]');
    var next = root.querySelector('[data-bb-next]');
    function step() {
      var first = track.querySelector(':scope > *');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  }
  function initAll() {
    document.querySelectorAll('[data-bb-carousel]').forEach(initCarousel);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  // Re-init when Shopify theme editor adds/changes a section
  document.addEventListener('shopify:section:load', initAll);
})();
